
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 48h40a4 4 0 004-4V16a4 4 0 00-4-4H12a4 4 0 00-4 4v28a4 4 0 004 4zM40 56H24","stroke":"#000C1F","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M40 30l-12-8v16l12-8z","stroke":"currentColor","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    